import React from 'react';
import classNames from 'classnames';

import { SUSPENDED_EMAIL } from '../../util/safetySuspended';

import css from './SuspendedNotice.module.css';

/**
 * Community Guidelines suspension notice. Shown instead of "Oops" on any
 * safety_suspended 403 and next to disabled Book / Start now buttons.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {boolean} [props.compact]
 */
const SuspendedNotice = props => {
  const { className, compact = false } = props;
  return (
    <div
      className={classNames(css.root, { [css.compact]: compact }, className)}
      role="alert"
      data-testid="suspended-notice"
    >
      <p className={css.text}>
        Your account is suspended for breaking our Community Guidelines. If you think this is a
        mistake, email{' '}
        <a className={css.link} href={`mailto:${SUSPENDED_EMAIL}`}>
          {SUSPENDED_EMAIL}
        </a>{' '}
        to dispute it. We reply within one business day.
      </p>
    </div>
  );
};

export default SuspendedNotice;
